<template>
  <div class="sidebar">
    <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#fff"
      text-color="#717171"
      active-text-color="#FF7116"
      unique-opened
      router
      mode="vertical"
    >
      <sider-bar-item
        v-for="route in routes"
        :key="route.path"
        :orderCount="orderCount"
        :item="route"
        :base-path="route.path"/>
    </el-menu>
  </div>
</template>

<script>
import SiderBarItem from "./siderbar-item";
import {
  orderCount
} from "$merChantApi/tw-order-boss";
import Store from "$common/utils/store";

export default {
  components: { SiderBarItem },
  data() {
    return {
      timer: null,
      orderCount: {}
    }
  },
  computed: {
    routes() {
      return this.$router.options.routes
    },
    onRoutes() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    collapse() {
      return this.$store.state.collapse
    }
  },
  created() {
    orderCount({ storeNo: Store.loadObject('storeNo') }, {
      success: async res => {
        if (res.rspCd + '' === '00000') {
          await this.$store.commit('SET_SIDER_BAR_COUNT', res.data)
          Store.saveObject('orderCount', res.data || {})
          this.$set(this, 'orderCount', res.data)
        }
      }
    })
  }
}
</script>

<style scoped>
.sidebar {
  width: 210px;
  display: block;
  position: absolute;
  left: 0;
  top: 4rem;
  bottom: 0;
  overflow-y: scroll;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 210px;
}

.sidebar > ul {
  height: 100%;
}
</style>
